import React from 'react';

const Dot = ({ color, label }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 12 }}>
    <span style={{ width: 10, height: 10, borderRadius: '50%', background: color, display: 'inline-block', marginRight: 6 }} />
    <span style={{ fontSize: 12 }}>{label}</span>
  </span>
);

const MapLegend = () => {
  return (
    <div style={{
      position: 'absolute',
      left: 10,
      bottom: 10,
      zIndex: 11,
      background: 'rgba(20,20,20,0.6)',
      color: 'white',
      padding: '6px 10px',
      borderRadius: 8,
      backdropFilter: 'blur(6px)'
    }}>
      <Dot color="#f59e0b" label="Requisito" />
      <Dot color="#22c55e" label="Desbloquea" />
      <Dot color="#38bdf8" label="Cursando" />
      <Dot color="#22c55e" label="Aprobada" />
      <Dot color="#e5e7eb" label="Pendiente" />
    </div>
  );
};

export default MapLegend;


